import { render, staticRenderFns } from "./AdminManageAvailability.vue?vue&type=template&id=4b4cc1f8"
import script from "./AdminManageAvailability.vue?vue&type=script&lang=js"
export * from "./AdminManageAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports